import { Tbody as ChakraTbody } from "@chakra-ui/react";

export const Tbody = ChakraTbody;
